import React from 'react';
import './styles.css'

class SuccessMessage extends React.Component {
    render() {

        const {message, renderFunc } = this.props;

        return (
            <div>
                { message &&
                    <div class='successMessageContainer'>
                        <p>{message}</p>
                        <img src='./assets/edit_icon.png' />
                    </div>
                }
                { renderFunc &&
                    <div className='successMessageContainer'>
                        {renderFunc()}
                        <img src='./assets/edit_icon.png' />
                    </div>}
            </div>
        );
    };
}

export default SuccessMessage;


// WEBPACK FOOTER //
// ./src/components/SuccessMessage/index.js